module.exports = __webpack_public_path__ + "static/media/Landing-BG-sm.2a984161.jpg";